"use strict";
/**
 * SDKErrors are KILT-specific errors, with associated codes and descriptions.
 *
 * @packageDocumentation
 * @module SDKErrors
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_NO_PROOF_FOR_STATEMENT = exports.ERROR_INVALID_PROOF_FOR_STATEMENT = exports.ERROR_PE_VERIFICATION = exports.ERROR_TIMEOUT = exports.ERROR_UNKNOWN = exports.ERROR_MESSAGE_TYPE = exports.ERROR_PARSING_MESSAGE = exports.ERROR_DECODING_MESSAGE = exports.ERROR_COMPRESS_OBJECT = exports.ERROR_DECOMPRESSION_ARRAY = exports.ERROR_ROOT_HASH_UNVERIFIABLE = exports.ERROR_WS_ADDRESS_NOT_SET = exports.ERROR_IDENTITY_NOT_PE_ENABLED = exports.ERROR_IDENTITY_MISMATCH = exports.ERROR_MNEMONIC_PHRASE_INVALID = exports.ERROR_CTYPE_HASH_INVALID = exports.ERROR_NESTED_CLAIM_UNVERIFIABLE = exports.ERROR_CLAIM_UNVERIFIABLE = exports.ERROR_ATTESTEDCLAIM_UNVERIFIABLE = exports.ERROR_SIGNATURE_UNVERIFIABLE = exports.ERROR_LEGITIMATIONS_UNVERIFIABLE = exports.ERROR_NONCE_HASH_INVALID = exports.ERROR_ADDRESS_INVALID = exports.ERROR_INVALID_DID_PREFIX = exports.ERROR_NODE_QUERY = exports.ERROR_ROOT_NODE_QUERY = exports.ERROR_PE_MISMATCH = exports.ERROR_DID_IDENTIFIER_MISMATCH = exports.ERROR_SIGNATURE_DATA_TYPE = exports.ERROR_CLAIM_HASHTREE_MISMATCH = exports.ERROR_MESSAGE_BODY_MALFORMED = exports.ERROR_CLAIM_NONCE_MAP_MALFORMED = exports.ERROR_QUOTE_MALFORMED = exports.ERROR_MNEMONIC_PHRASE_MALFORMED = exports.ERROR_CTYPE_OWNER_TYPE = exports.ERROR_OBJECT_MALFORMED = exports.ERROR_CLAIM_CONTENTS_MALFORMED = exports.ERROR_DELEGATION_ID_MISSING = exports.ERROR_DELEGATION_ID_TYPE = exports.ERROR_HASH_MALFORMED = exports.ERROR_HASH_TYPE = exports.ERROR_ADDRESS_TYPE = exports.ERROR_CLAIM_NOT_PROVIDED = exports.ERROR_CLAIM_NONCE_MAP_NOT_PROVIDED = exports.ERROR_PE_CREDENTIAL_MISSING = exports.ERROR_PE_MISSING = exports.ERROR_ATTESTATION_SESSION_MISSING = exports.ERROR_LEGITIMATIONS_NOT_PROVIDED = exports.ERROR_RFA_NOT_PROVIDED = exports.ERROR_ATTESTATION_NOT_PROVIDED = exports.ERROR_OWNER_NOT_PROVIDED = exports.ERROR_REVOCATION_BIT_MISSING = exports.ERROR_CLAIM_HASH_NOT_PROVIDED = exports.ERROR_CTYPE_PROPERTIES_NOT_MATCHING = exports.ERROR_CTYPE_ID_NOT_MATCHING = exports.ERROR_CTYPE_HASH_NOT_PROVIDED = exports.ERROR_NOT_FOUND = exports.ERROR_UNAUTHORIZED = exports.ERROR_TRANSACTION_USURPED = exports.ERROR_TRANSACTION_PRIORITY = exports.ERROR_TRANSACTION_DUPLICATE = exports.ERROR_TRANSACTION_OUTDATED = exports.ERROR_TRANSACTION_RECOVERABLE = exports.SDKError = exports.isSDKError = exports.ErrorCode = void 0;
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["ERROR_TRANSACTION_RECOVERABLE"] = 1000] = "ERROR_TRANSACTION_RECOVERABLE";
    ErrorCode[ErrorCode["ERROR_TRANSACTION_OUTDATED"] = 1010] = "ERROR_TRANSACTION_OUTDATED";
    ErrorCode[ErrorCode["ERROR_TRANSACTION_DUPLICATE"] = 1013] = "ERROR_TRANSACTION_DUPLICATE";
    ErrorCode[ErrorCode["ERROR_TRANSACTION_PRIORITY"] = 1014] = "ERROR_TRANSACTION_PRIORITY";
    ErrorCode[ErrorCode["ERROR_TRANSACTION_USURPED"] = 1015] = "ERROR_TRANSACTION_USURPED";
    ErrorCode[ErrorCode["ERROR_UNAUTHORIZED"] = 1016] = "ERROR_UNAUTHORIZED";
    ErrorCode[ErrorCode["ERROR_NOT_FOUND"] = 1017] = "ERROR_NOT_FOUND";
    // Data is missing
    ErrorCode[ErrorCode["ERROR_CTYPE_HASH_NOT_PROVIDED"] = 10001] = "ERROR_CTYPE_HASH_NOT_PROVIDED";
    ErrorCode[ErrorCode["ERROR_CLAIM_HASH_NOT_PROVIDED"] = 10002] = "ERROR_CLAIM_HASH_NOT_PROVIDED";
    ErrorCode[ErrorCode["ERROR_CLAIM_NONCE_MAP_NOT_PROVIDED"] = 10003] = "ERROR_CLAIM_NONCE_MAP_NOT_PROVIDED";
    ErrorCode[ErrorCode["ERROR_CLAIM_NOT_PROVIDED"] = 10004] = "ERROR_CLAIM_NOT_PROVIDED";
    ErrorCode[ErrorCode["ERROR_OWNER_NOT_PROVIDED"] = 10005] = "ERROR_OWNER_NOT_PROVIDED";
    ErrorCode[ErrorCode["ERROR_RFA_NOT_PROVIDED"] = 10006] = "ERROR_RFA_NOT_PROVIDED";
    ErrorCode[ErrorCode["ERROR_ATTESTATION_NOT_PROVIDED"] = 10007] = "ERROR_ATTESTATION_NOT_PROVIDED";
    ErrorCode[ErrorCode["ERROR_REVOCATION_BIT_MISSING"] = 10008] = "ERROR_REVOCATION_BIT_MISSING";
    ErrorCode[ErrorCode["ERROR_LEGITIMATIONS_NOT_PROVIDED"] = 10009] = "ERROR_LEGITIMATIONS_NOT_PROVIDED";
    ErrorCode[ErrorCode["ERROR_ATTESTATION_SESSION_MISSING"] = 10010] = "ERROR_ATTESTATION_SESSION_MISSING";
    ErrorCode[ErrorCode["ERROR_PE_MISSING"] = 10011] = "ERROR_PE_MISSING";
    ErrorCode[ErrorCode["ERROR_PE_CREDENTIAL_MISSING"] = 10012] = "ERROR_PE_CREDENTIAL_MISSING";
    ErrorCode[ErrorCode["ERROR_CTYPE_ID_NOT_MATCHING"] = 10013] = "ERROR_CTYPE_ID_NOT_MATCHING";
    ErrorCode[ErrorCode["ERROR_PE_VERIFICATION"] = 10014] = "ERROR_PE_VERIFICATION";
    ErrorCode[ErrorCode["ERROR_NO_PROOF_FOR_STATEMENT"] = 10015] = "ERROR_NO_PROOF_FOR_STATEMENT";
    ErrorCode[ErrorCode["ERROR_IDENTITY_NOT_PE_ENABLED"] = 10016] = "ERROR_IDENTITY_NOT_PE_ENABLED";
    ErrorCode[ErrorCode["ERROR_WS_ADDRESS_NOT_SET"] = 10017] = "ERROR_WS_ADDRESS_NOT_SET";
    ErrorCode[ErrorCode["ERROR_DELEGATION_ID_MISSING"] = 10018] = "ERROR_DELEGATION_ID_MISSING";
    // Data type is wrong or malformed
    ErrorCode[ErrorCode["ERROR_ADDRESS_TYPE"] = 20001] = "ERROR_ADDRESS_TYPE";
    ErrorCode[ErrorCode["ERROR_HASH_TYPE"] = 20002] = "ERROR_HASH_TYPE";
    ErrorCode[ErrorCode["ERROR_HASH_MALFORMED"] = 20003] = "ERROR_HASH_MALFORMED";
    ErrorCode[ErrorCode["ERROR_SIGNATURE_DATA_TYPE"] = 20005] = "ERROR_SIGNATURE_DATA_TYPE";
    ErrorCode[ErrorCode["ERROR_CTYPE_OWNER_TYPE"] = 20006] = "ERROR_CTYPE_OWNER_TYPE";
    ErrorCode[ErrorCode["ERROR_DELEGATION_ID_TYPE"] = 20007] = "ERROR_DELEGATION_ID_TYPE";
    ErrorCode[ErrorCode["ERROR_CLAIM_CONTENTS_MALFORMED"] = 20009] = "ERROR_CLAIM_CONTENTS_MALFORMED";
    ErrorCode[ErrorCode["ERROR_CLAIM_NONCE_MAP_MALFORMED"] = 20010] = "ERROR_CLAIM_NONCE_MAP_MALFORMED";
    ErrorCode[ErrorCode["ERROR_OBJECT_MALFORMED"] = 20011] = "ERROR_OBJECT_MALFORMED";
    ErrorCode[ErrorCode["ERROR_MNEMONIC_PHRASE_MALFORMED"] = 20012] = "ERROR_MNEMONIC_PHRASE_MALFORMED";
    ErrorCode[ErrorCode["ERROR_QUOTE_MALFORMED"] = 20013] = "ERROR_QUOTE_MALFORMED";
    ErrorCode[ErrorCode["ERROR_CLAIM_HASHTREE_MISMATCH"] = 20014] = "ERROR_CLAIM_HASHTREE_MISMATCH";
    ErrorCode[ErrorCode["ERROR_PE_MISMATCH"] = 20015] = "ERROR_PE_MISMATCH";
    ErrorCode[ErrorCode["ERROR_DID_IDENTIFIER_MISMATCH"] = 20016] = "ERROR_DID_IDENTIFIER_MISMATCH";
    ErrorCode[ErrorCode["ERROR_ROOT_NODE_QUERY"] = 20017] = "ERROR_ROOT_NODE_QUERY";
    ErrorCode[ErrorCode["ERROR_INVALID_DID_PREFIX"] = 20018] = "ERROR_INVALID_DID_PREFIX";
    ErrorCode[ErrorCode["ERROR_MESSAGE_BODY_MALFORMED"] = 20019] = "ERROR_MESSAGE_BODY_MALFORMED";
    ErrorCode[ErrorCode["ERROR_NODE_QUERY"] = 20020] = "ERROR_NODE_QUERY";
    // Data is invalid
    ErrorCode[ErrorCode["ERROR_ADDRESS_INVALID"] = 30001] = "ERROR_ADDRESS_INVALID";
    ErrorCode[ErrorCode["ERROR_NONCE_HASH_INVALID"] = 30002] = "ERROR_NONCE_HASH_INVALID";
    ErrorCode[ErrorCode["ERROR_LEGITIMATIONS_UNVERIFIABLE"] = 30003] = "ERROR_LEGITIMATIONS_UNVERIFIABLE";
    ErrorCode[ErrorCode["ERROR_SIGNATURE_UNVERIFIABLE"] = 30004] = "ERROR_SIGNATURE_UNVERIFIABLE";
    ErrorCode[ErrorCode["ERROR_ATTESTEDCLAIM_UNVERIFIABLE"] = 30005] = "ERROR_ATTESTEDCLAIM_UNVERIFIABLE";
    ErrorCode[ErrorCode["ERROR_CLAIM_UNVERIFIABLE"] = 30006] = "ERROR_CLAIM_UNVERIFIABLE";
    ErrorCode[ErrorCode["ERROR_CTYPE_HASH_INVALID"] = 30007] = "ERROR_CTYPE_HASH_INVALID";
    ErrorCode[ErrorCode["ERROR_MNEMONIC_PHRASE_INVALID"] = 30008] = "ERROR_MNEMONIC_PHRASE_INVALID";
    ErrorCode[ErrorCode["ERROR_IDENTITY_MISMATCH"] = 30009] = "ERROR_IDENTITY_MISMATCH";
    ErrorCode[ErrorCode["ERROR_ROOT_HASH_UNVERIFIABLE"] = 30010] = "ERROR_ROOT_HASH_UNVERIFIABLE";
    ErrorCode[ErrorCode["ERROR_NESTED_CLAIM_UNVERIFIABLE"] = 30011] = "ERROR_NESTED_CLAIM_UNVERIFIABLE";
    ErrorCode[ErrorCode["ERROR_INVALID_PROOF_FOR_STATEMENT"] = 30012] = "ERROR_INVALID_PROOF_FOR_STATEMENT";
    ErrorCode[ErrorCode["ERROR_CTYPE_PROPERTIES_NOT_MATCHING"] = 30013] = "ERROR_CTYPE_PROPERTIES_NOT_MATCHING";
    // Compression / Decompressions
    ErrorCode[ErrorCode["ERROR_DECOMPRESSION_ARRAY"] = 40001] = "ERROR_DECOMPRESSION_ARRAY";
    ErrorCode[ErrorCode["ERROR_COMPRESS_OBJECT"] = 40002] = "ERROR_COMPRESS_OBJECT";
    ErrorCode[ErrorCode["ERROR_DECODING_MESSAGE"] = 40003] = "ERROR_DECODING_MESSAGE";
    ErrorCode[ErrorCode["ERROR_PARSING_MESSAGE"] = 40004] = "ERROR_PARSING_MESSAGE";
    ErrorCode[ErrorCode["ERROR_MESSAGE_TYPE"] = 40005] = "ERROR_MESSAGE_TYPE";
    ErrorCode[ErrorCode["ERROR_UNKNOWN"] = -1] = "ERROR_UNKNOWN";
    ErrorCode[ErrorCode["ERROR_TIMEOUT"] = -2] = "ERROR_TIMEOUT";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
function isSDKError(input) {
    return (((i) => i instanceof Error)(input) &&
        input.errorCode !== undefined &&
        input.errorCode in ErrorCode);
}
exports.isSDKError = isSDKError;
class SDKError extends Error {
    constructor(errorCode, message) {
        super(message);
        this.errorCode = errorCode;
    }
}
exports.SDKError = SDKError;
exports.ERROR_TRANSACTION_RECOVERABLE = () => {
    return new SDKError(ErrorCode.ERROR_TRANSACTION_RECOVERABLE, 'Tx failed due to nonce collision, this is recoverable by re-signing!');
};
exports.ERROR_TRANSACTION_OUTDATED = () => {
    return new SDKError(ErrorCode.ERROR_TRANSACTION_OUTDATED, 'Tx was signed with outdated Nonce');
};
exports.ERROR_TRANSACTION_DUPLICATE = () => {
    return new SDKError(ErrorCode.ERROR_TRANSACTION_DUPLICATE, 'Identical Tx was already imported to the pool');
};
exports.ERROR_TRANSACTION_PRIORITY = () => {
    return new SDKError(ErrorCode.ERROR_TRANSACTION_PRIORITY, 'Tx Priority too low to replace existing Tx with equal nonce');
};
exports.ERROR_TRANSACTION_USURPED = () => {
    return new SDKError(ErrorCode.ERROR_TRANSACTION_USURPED, 'Tx was replaced by another TX with the same Nonce and higher Priority');
};
exports.ERROR_UNAUTHORIZED = (msg) => {
    return new SDKError(ErrorCode.ERROR_UNAUTHORIZED, msg);
};
exports.ERROR_NOT_FOUND = (msg) => {
    return new SDKError(ErrorCode.ERROR_NOT_FOUND, msg);
};
exports.ERROR_CTYPE_HASH_NOT_PROVIDED = () => {
    return new SDKError(ErrorCode.ERROR_CTYPE_HASH_NOT_PROVIDED, 'CType hash missing');
};
exports.ERROR_CTYPE_ID_NOT_MATCHING = (fromSchema, provided) => {
    return new SDKError(ErrorCode.ERROR_CTYPE_ID_NOT_MATCHING, `Provided $id "${provided}" and schema $id "${fromSchema}" are not matching`);
};
exports.ERROR_CTYPE_PROPERTIES_NOT_MATCHING = () => {
    return new SDKError(ErrorCode.ERROR_CTYPE_PROPERTIES_NOT_MATCHING, 'Required properties do not match CType properties');
};
exports.ERROR_CLAIM_HASH_NOT_PROVIDED = () => {
    return new SDKError(ErrorCode.ERROR_CLAIM_HASH_NOT_PROVIDED, 'Claim hash missing');
};
exports.ERROR_REVOCATION_BIT_MISSING = () => {
    return new SDKError(ErrorCode.ERROR_REVOCATION_BIT_MISSING, 'Revoked identifier missing');
};
exports.ERROR_OWNER_NOT_PROVIDED = () => {
    return new SDKError(ErrorCode.ERROR_OWNER_NOT_PROVIDED, 'Owner missing');
};
exports.ERROR_ATTESTATION_NOT_PROVIDED = () => {
    return new SDKError(ErrorCode.ERROR_ATTESTATION_NOT_PROVIDED, 'Attestation missing');
};
exports.ERROR_RFA_NOT_PROVIDED = () => {
    return new SDKError(ErrorCode.ERROR_RFA_NOT_PROVIDED, 'RequestForAttestation missing');
};
exports.ERROR_LEGITIMATIONS_NOT_PROVIDED = () => {
    return new SDKError(ErrorCode.ERROR_LEGITIMATIONS_NOT_PROVIDED, 'Legitimations missing');
};
exports.ERROR_ATTESTATION_SESSION_MISSING = () => {
    return new SDKError(ErrorCode.ERROR_ATTESTATION_SESSION_MISSING, 'Privacy enhancement was forced, but attestation session is missing.');
};
exports.ERROR_PE_MISSING = () => {
    return new SDKError(ErrorCode.ERROR_PE_MISSING, 'Privacy enhancement is missing.');
};
exports.ERROR_PE_CREDENTIAL_MISSING = () => {
    return new SDKError(ErrorCode.ERROR_PE_CREDENTIAL_MISSING, 'Missing privacy enhanced credential.');
};
exports.ERROR_CLAIM_NONCE_MAP_NOT_PROVIDED = () => {
    return new SDKError(ErrorCode.ERROR_CLAIM_NONCE_MAP_NOT_PROVIDED, 'Hashtree in Claim missing');
};
exports.ERROR_CLAIM_NOT_PROVIDED = () => {
    return new SDKError(ErrorCode.ERROR_CLAIM_NOT_PROVIDED, 'Hashtree in Claim missing');
};
exports.ERROR_ADDRESS_TYPE = () => {
    return new SDKError(ErrorCode.ERROR_ADDRESS_TYPE, 'Address of wrong type');
};
exports.ERROR_HASH_TYPE = () => {
    return new SDKError(ErrorCode.ERROR_HASH_TYPE, 'Hash of wrong type');
};
exports.ERROR_HASH_MALFORMED = (hash, type) => {
    if (hash && type) {
        return new SDKError(ErrorCode.ERROR_HASH_MALFORMED, `Provided ${type} hash invalid or malformed \nHash: ${hash}`);
    }
    if (hash) {
        return new SDKError(ErrorCode.ERROR_HASH_MALFORMED, `Provided hash invalid or malformed \nHash: ${hash}`);
    }
    return new SDKError(ErrorCode.ERROR_HASH_MALFORMED, `Provided hash invalid or malformed`);
};
exports.ERROR_DELEGATION_ID_TYPE = () => {
    return new SDKError(ErrorCode.ERROR_DELEGATION_ID_TYPE, 'DelegationId of wrong type');
};
exports.ERROR_DELEGATION_ID_MISSING = () => {
    return new SDKError(ErrorCode.ERROR_DELEGATION_ID_MISSING, 'DelegationId is missing');
};
exports.ERROR_CLAIM_CONTENTS_MALFORMED = () => {
    return new SDKError(ErrorCode.ERROR_CLAIM_CONTENTS_MALFORMED, 'Claim contents malformed');
};
exports.ERROR_OBJECT_MALFORMED = () => {
    return new SDKError(ErrorCode.ERROR_OBJECT_MALFORMED, 'Object form is not verifiable');
};
exports.ERROR_CTYPE_OWNER_TYPE = () => {
    return new SDKError(ErrorCode.ERROR_CTYPE_OWNER_TYPE, 'CType owner of wrong type');
};
exports.ERROR_MNEMONIC_PHRASE_MALFORMED = () => {
    return new SDKError(ErrorCode.ERROR_MNEMONIC_PHRASE_MALFORMED, 'Mnemonic phrase malformed or too short');
};
exports.ERROR_QUOTE_MALFORMED = () => {
    return new SDKError(ErrorCode.ERROR_QUOTE_MALFORMED, 'Quote form is not verifiable');
};
exports.ERROR_CLAIM_NONCE_MAP_MALFORMED = (statement) => {
    let message = '';
    if (statement) {
        message = `Nonce map malformed or incomplete: no nonce for statement "${statement}"`;
    }
    else {
        message = `Nonce map malformed or incomplete`;
    }
    return new SDKError(ErrorCode.ERROR_CLAIM_NONCE_MAP_MALFORMED, message);
};
exports.ERROR_MESSAGE_BODY_MALFORMED = () => {
    return new SDKError(ErrorCode.ERROR_MESSAGE_BODY_MALFORMED, 'Message body is malformed or wrong type');
};
exports.ERROR_CLAIM_HASHTREE_MISMATCH = (key) => {
    if (key) {
        return new SDKError(ErrorCode.ERROR_CLAIM_HASHTREE_MISMATCH, `Property '${key}' not found in claim`);
    }
    return new SDKError(ErrorCode.ERROR_CLAIM_HASHTREE_MISMATCH, `Property not found in claim`);
};
exports.ERROR_SIGNATURE_DATA_TYPE = () => {
    return new SDKError(ErrorCode.ERROR_SIGNATURE_DATA_TYPE, 'Property non existent');
};
exports.ERROR_DID_IDENTIFIER_MISMATCH = (identifier, id) => {
    return new SDKError(ErrorCode.ERROR_DID_IDENTIFIER_MISMATCH, `This identifier (${identifier}) doesn't match the DID Document's identifier (${id})`);
};
exports.ERROR_PE_MISMATCH = () => {
    return new SDKError(ErrorCode.ERROR_PE_MISMATCH, 'Verifier requested public presentation, but privacy enhancement was forced.');
};
exports.ERROR_ROOT_NODE_QUERY = (rootId) => {
    return new SDKError(ErrorCode.ERROR_ROOT_NODE_QUERY, `Could not find root node with id ${rootId}`);
};
exports.ERROR_NODE_QUERY = (nodeId) => {
    return new SDKError(ErrorCode.ERROR_NODE_QUERY, `Could not find node with id ${nodeId}`);
};
exports.ERROR_INVALID_DID_PREFIX = (identifier) => {
    return new SDKError(ErrorCode.ERROR_INVALID_DID_PREFIX, `Not a KILT did: ${identifier}`);
};
exports.ERROR_ADDRESS_INVALID = (address, type) => {
    if (address && type) {
        return new SDKError(ErrorCode.ERROR_ADDRESS_INVALID, `Provided ${type} address invalid \n\n    Address: ${address}`);
    }
    if (address) {
        return new SDKError(ErrorCode.ERROR_ADDRESS_INVALID, `Provided address invalid \n\n    Address: ${address}`);
    }
    return new SDKError(ErrorCode.ERROR_ADDRESS_INVALID, `Provided address invalid`);
};
exports.ERROR_NONCE_HASH_INVALID = (nonceHash, type) => {
    if (nonceHash && type) {
        return new SDKError(ErrorCode.ERROR_NONCE_HASH_INVALID, `Provided ${type} NonceHash invalid \n    Hash: ${nonceHash.hash} \n    Nonce: ${nonceHash.nonce}`);
    }
    if (nonceHash) {
        return new SDKError(ErrorCode.ERROR_NONCE_HASH_INVALID, `Provided NonceHash invalid \nHash: ${nonceHash}`);
    }
    return new SDKError(ErrorCode.ERROR_NONCE_HASH_INVALID, 'NonceHash could not be validated');
};
exports.ERROR_LEGITIMATIONS_UNVERIFIABLE = () => {
    return new SDKError(ErrorCode.ERROR_LEGITIMATIONS_UNVERIFIABLE, 'Legitimations could not be verified');
};
exports.ERROR_SIGNATURE_UNVERIFIABLE = () => {
    return new SDKError(ErrorCode.ERROR_SIGNATURE_UNVERIFIABLE, 'Signature could not be verified');
};
exports.ERROR_ATTESTEDCLAIM_UNVERIFIABLE = () => {
    return new SDKError(ErrorCode.ERROR_ATTESTEDCLAIM_UNVERIFIABLE, 'AttestedClaim could not be verified');
};
exports.ERROR_CLAIM_UNVERIFIABLE = () => {
    return new SDKError(ErrorCode.ERROR_CLAIM_UNVERIFIABLE, 'Claim could not be verified');
};
exports.ERROR_NESTED_CLAIM_UNVERIFIABLE = () => {
    return new SDKError(ErrorCode.ERROR_NESTED_CLAIM_UNVERIFIABLE, 'Nested claim data does not validate against CType');
};
exports.ERROR_CTYPE_HASH_INVALID = () => {
    return new SDKError(ErrorCode.ERROR_CTYPE_HASH_INVALID, 'CType Hash could not be validated');
};
exports.ERROR_MNEMONIC_PHRASE_INVALID = () => {
    return new SDKError(ErrorCode.ERROR_MNEMONIC_PHRASE_INVALID, 'Mnemonic phrase invalid');
};
exports.ERROR_IDENTITY_MISMATCH = (context, type) => {
    if (type && context) {
        return new SDKError(ErrorCode.ERROR_IDENTITY_MISMATCH, `${type} is not owner of the ${context}`);
    }
    if (context) {
        return new SDKError(ErrorCode.ERROR_IDENTITY_MISMATCH, `Identity is not owner of the ${context}`);
    }
    return new SDKError(ErrorCode.ERROR_IDENTITY_MISMATCH, 'Addresses expected to be equal mismatched');
};
exports.ERROR_IDENTITY_NOT_PE_ENABLED = () => {
    return new SDKError(ErrorCode.ERROR_IDENTITY_NOT_PE_ENABLED, 'Identity is not privacy enhaced');
};
exports.ERROR_WS_ADDRESS_NOT_SET = () => {
    return new SDKError(ErrorCode.ERROR_WS_ADDRESS_NOT_SET, 'Node address to connect to not configured!');
};
exports.ERROR_ROOT_HASH_UNVERIFIABLE = () => {
    return new SDKError(ErrorCode.ERROR_ROOT_HASH_UNVERIFIABLE, 'RootHash could not be verified');
};
exports.ERROR_DECOMPRESSION_ARRAY = (type) => {
    if (type) {
        return new SDKError(ErrorCode.ERROR_DECOMPRESSION_ARRAY, `Provided compressed ${type} not an Array or not of defined length`);
    }
    return new SDKError(ErrorCode.ERROR_DECOMPRESSION_ARRAY, 'Provided compressed object not an Array or not of defined length');
};
exports.ERROR_COMPRESS_OBJECT = (object, type) => {
    if (object && type) {
        return new SDKError(ErrorCode.ERROR_COMPRESS_OBJECT, `Property Not Provided while compressing ${type}:\n${JSON.stringify(object, null, 2)}`);
    }
    if (object) {
        return new SDKError(ErrorCode.ERROR_COMPRESS_OBJECT, `Property Not Provided while compressing object:\n${JSON.stringify(object, null, 2)}`);
    }
    return new SDKError(ErrorCode.ERROR_COMPRESS_OBJECT, `Property Not Provided while compressing object`);
};
exports.ERROR_DECODING_MESSAGE = () => {
    return new SDKError(ErrorCode.ERROR_DECODING_MESSAGE, 'Error decoding message');
};
exports.ERROR_PARSING_MESSAGE = () => {
    return new SDKError(ErrorCode.ERROR_PARSING_MESSAGE, 'Error parsing message body');
};
exports.ERROR_MESSAGE_TYPE = (type, expectedType, alternativeType) => {
    if (alternativeType) {
        return new SDKError(ErrorCode.ERROR_MESSAGE_TYPE, `Unexpected message type. Received ${type}, expected ${expectedType} or ${alternativeType}`);
    }
    return new SDKError(ErrorCode.ERROR_MESSAGE_TYPE, `Unexpected message type. Received ${type}, expected ${expectedType}`);
};
exports.ERROR_UNKNOWN = () => {
    return new SDKError(ErrorCode.ERROR_UNKNOWN, 'an unknown error ocurred');
};
exports.ERROR_TIMEOUT = () => {
    return new SDKError(ErrorCode.ERROR_TIMEOUT, 'operation timed out');
};
exports.ERROR_PE_VERIFICATION = (accFailure, keyFailure) => {
    return new SDKError(ErrorCode.ERROR_PE_VERIFICATION, `Received privacy enhanced presentation with insufficient data. 
    \n\tMissing accumulators? ${accFailure}
    \n\tMissing attester public keys? ${keyFailure}
    `);
};
exports.ERROR_INVALID_PROOF_FOR_STATEMENT = (statement) => {
    return new SDKError(ErrorCode.ERROR_INVALID_PROOF_FOR_STATEMENT, `Proof could not be verified for statement\n${statement}`);
};
exports.ERROR_NO_PROOF_FOR_STATEMENT = (statement) => {
    return new SDKError(ErrorCode.ERROR_NO_PROOF_FOR_STATEMENT, `No matching proof found for statement\n${statement}`);
};
